import produce from "immer";
import { actionName, RelodeAppActionTypes } from "./relodeAppActionTypes";
import { RelodeAppState } from "./relodeAppState";
import { updateRelodeSettings } from "./relodeSettings";

const MAX_API_FAILURE_COUNT = 10;

export const relodeAppReducer = (
    state: RelodeAppState,
    action: RelodeAppActionTypes
) =>
    produce(state, draft => {
        switch (action.type) {
            case actionName.API_CALL_SUCCESSFUL: {
                draft.apiFailureCount = 0;
                draft.haltApiCalls = false;
                break;
            }

            case actionName.API_CALL_FAILURE: {
                draft.apiFailureCount++;
                draft.haltApiCalls =
                    draft.apiFailureCount >= MAX_API_FAILURE_COUNT;
                break;
            }

            case actionName.APP_OFFLINE: {
                draft.haltApiCalls = true;
                break;
            }

            case actionName.APP_ONLINE: {
                draft.haltApiCalls = false;
                break;
            }

            case actionName.SET_CURRENT_USER: {
                draft.currentUser = action.payload.user;
                break;
            }

            case actionName.SET_TEAM_PLAN_FEATURES: {
                draft.teamPlanFeatures = action.payload.teamPlanFeatures;
                break;
            }

            case actionName.OPEN_MENU: {
                draft.settings.user.isMenuOpen = true;
                updateRelodeSettings({ user: { isMenuOpen: true } });
                break;
            }

            case actionName.CLOSE_MENU: {
                draft.settings.user.isMenuOpen = false;
                updateRelodeSettings({ user: { isMenuOpen: false } });
                break;
            }

            case actionName.TOGGLE_MENU: {
                const isMenuOpen = !state.settings.user.isMenuOpen;
                draft.settings.user.isMenuOpen = isMenuOpen;
                updateRelodeSettings({ user: { isMenuOpen: isMenuOpen } });
                break;
            }
        }
    });
